"use strict";
// tslint:disable
// eslint-disable
/**
 * Roles and Rights API
 * API for configurable roles and rights
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
function RoleUpdateFromJSON(json) {
    return RoleUpdateFromJSONTyped(json, false);
}
exports.RoleUpdateFromJSON = RoleUpdateFromJSON;
function RoleUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'rights': !runtime_1.exists(json, 'rights') ? undefined : json['rights'],
    };
}
exports.RoleUpdateFromJSONTyped = RoleUpdateFromJSONTyped;
function RoleUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'rights': value.rights,
    };
}
exports.RoleUpdateToJSON = RoleUpdateToJSON;
